import React from 'react';

import { Button } from 'components/base/button';
import { Colors } from 'theme/colors';
import { Container } from 'theme/layout';
import { Medium, Regular } from 'theme/text';

const MAX_WIDTH = 200;

/**
 * Renders an error message when there are issues with
 * the messenger fails to start.
 *
 * @param props - Error message props.
 */
export function FailedStart(props: Props) {
  const { onRetry, onGetHelp, visible, accentColor } = props;

  if (!visible) {
    return null;
  }

  return (
    <Container display="flex" flexDirection="column" alignItems="center">
      <Regular textAlign="center">
        We&apos;re having trouble loading the chat. Please check your connection and retry.
      </Regular>
      <Container width={MAX_WIDTH} mt={4}>
        <Button accentColor={accentColor} onPress={onRetry} rounded>
          <Medium color={Colors.white}>Retry</Medium>
        </Button>
        <Button accentColor={Colors.white} onPress={onGetHelp}>
          <Regular color={Colors.stack}>Get help</Regular>
        </Button>
      </Container>
    </Container>
  );
}
interface Props {
  /** Indicates whether to show the component or not */
  visible: boolean;
  /** Emits an `onRetry` event when the retry button is pressed. */
  onRetry?(): void;
  /** Emits an `onGetHelp` event when the get help button is pressed. */
  onGetHelp?(): void;
  /** CoBranding accent color to be used in buttons and potentially other controls */
  accentColor: string;
}
